import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login, verifyEmail, isLoggedIn, userToken, logout} from "../../../features/user";
import { setLoading, showMessage} from "../../../features/common";
import axios from "axios";
import { API_OK, API_204, API_404, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans, useTranslation } from 'react-i18next';
import {checkValidToken, getLang} from "../../../Helper"
import cookie from "js-cookie";
import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';

export function ResetPassword() {
    const [state, setState] = useState({ email: "", code: "",password: "", errors: {}, showChangePassword: false, show: false });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);

    const handleChange = (e) => {
        delete state.errors[e.target.id];
        setState({
            ...state,
            [e.target.id]: e.target.value,
            errors: {}
        });
    };

    const handleNumberChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'),
            errors: {},
            message: null
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            setState({
                ...state,
                errors: {}
            });
            let errorMessage = t(DEFAULT_ERROR_TEXT);
          
            let config = {'headers': {"lang": getLang()}};
            const data = {email: state.email, passwordCode: state.showChangePassword?state.code:null, password: state.showChangePassword?state.password:null};
        
            try {
                const reply = await axios.patch(API_URL + '/users/password', data, config);
                // console.log(reply);
                if(reply.hasOwnProperty('status') && reply.status === API_204 ){
                    if(state.showChangePassword) {
                        navigate(-1);
                    } else {
                        setState({
                            ...state,
                            showChangePassword: true
                        })
                    }
                }
            } catch (e) {
                // console.log(e);
                if(e.response?.status === API_404) {
                    errorMessage = "reset_password_error";
                } else {
                    errorMessage = e.response?.data?.errors ? "please_fill_input" : errorMessage;
                }
                dispatch(showMessage({message : errorMessage}));
            }

        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }
    };

    const validateForm = () => {
        const errors = {};
        if(!state.showChangePassword) {
            if (!state.email?.trim()) {
                errors['email'] = 'email_error';
            }
        } else {
            if (!state.code?.trim()) {
                errors['code'] = 'verification_code_error';
            }
            if (!state.password?.trim()) {
                errors['password'] = 'password_error';
            }
        }

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };


    return (
        <Frame show={state.show}>
            <div className='main main-login'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        <Background showClouds={true}>
                            <div className='right-main-inner'>
                                <div className='mt20 text-align-center font-19 font-bold color-550952'>{t(!state.showChangePassword?"reset_password_title":"reset_password_title_code")}</div> 

                                {!state.showChangePassword && <div className='mt40'>
                                    <Input className={state.errors.email?"error":""} id="email" placeholder={t("email")} value={state.email??''} onChange={(e) => handleChange(e)}/>
                                </div>}
                                {state.errors.email && <div className='mt5 error font-12'><Trans i18nKey={state.errors.email} /></div>}


                                {state.showChangePassword && <div className='mt30'>
                                    <Input className={state.errors.code?"error":""} id="code" placeholder={t("verification_code")} value={state.code??''} onChange={(e) => handleNumberChange(e)}/>
                                </div>}
                                {state.errors.code && <div className='mt5 error font-12'><Trans i18nKey={state.errors.code} /></div>}


                                {state.showChangePassword && <div className='mt30'>
                                    <Input className={state.errors.password?"error":""} id="password" placeholder={t("new_password")} value={state.password??''} type='password' onChange={(e) => handleChange(e)}/>
                                </div>}
                                {state.errors.password && <div className='mt5 error font-12'><Trans i18nKey={state.errors.password} /></div>}


                                <div className='button mt70' onClick={(e) => handleSubmit(e)}>  <div>{t("next")}</div> </div>    
                            </div>
                        </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}